import script from "./BestPlayersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BestPlayersSection.vue?vue&type=script&setup=true&lang=js"

import "./BestPlayersSection.vue?vue&type=style&index=0&id=67aebaa5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67aebaa5"]])

export default __exports__